import styled from 'styled-components';
const StyledReviewListContainer = styled.div``;

export const InnerContainer = styled.div`
    padding: 20px;
`;
export default StyledReviewListContainer;
